import type { EnvironmentConfig } from '@core/config-models';
import { EnvConfigBrand, EnvConfigSegment } from '@core/config-models';

/**
 * Gets the aria-label for the logo-link (to be used in the headers & footer).
 */
export const getLogoHomepageNavigationLabel = (config: EnvironmentConfig) => {
  const isEssent = config.brand === EnvConfigBrand.Essent;
  const isConsument = config.segment === EnvConfigSegment.Consument;
  const brand = isEssent ? 'Essent' : 'Energiedirect';
  const segment = isConsument ? 'particulier' : 'zakelijk';
  const fullBrandName = isEssent ? `${brand} ${segment}` : brand;

  return `Logo ${fullBrandName} - naar ${fullBrandName} Homepage`;
};
